module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-09.a17fd0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-09.jpg
// module id = OzuZ
// module chunks = 51